import Layouts from '../../layouts/Layouts';
import AcidRefluxAndGerd from './acidRefluxAndGerd/AcidRefluxAndGerd';
import HeartBurn from './heartBurn/HeartBurn';
import ReadThisNext from './readThisNext/ReadThisNext';

function ArticleInnerPage() {
  return (
    <Layouts>
      <section className="articleInnerPage">
        <AcidRefluxAndGerd />
        <HeartBurn />
        <ReadThisNext />
      </section>
    </Layouts>
  );
}

export default ArticleInnerPage;
